import Footer from "../components/Footer";

export const ch = {
  more: "查看更多",
  learnMore: "了解详情",
  empty: "暂无数据",
  product: "产品分类",
  productIntroduce: "产品介绍",
  news: "上海百善动态与新闻",
  case: "精彩案例",
  server: "做值得信赖的服务商",
  company: "公司理念",
  companyList: [
    {
      title: "诚信经营",
      desc: "注重诚信经营，对客户诚信，对员工诚信，做一个讲诚信的企业",
      img: "http://47.117.168.187:8899/images/a1.png",
    },
    {
      title: "科技创新",
      desc: "持续进行科技创新，争取以最新的科技，创造最大的价值",
      img: "http://47.117.168.187:8899/images/a2.png",
    },
    {
      title: "共同发展",
      desc: "与员工，合作伙伴共同发展，共同进步，共享成果",
      img: "http://47.117.168.187:8899/images/a3.png",
    },
    {
      title: "企业远景",
      desc: "团队共同成长，稳求发展，创建可持续发展的运营模式",
      img: "http://47.117.168.187:8899/images/a4.png",
    },
  ],
  footer: {
    about: "关于我们",
    aboutList: ["公司简介", "企业文化"],
    product: "产品分类",
    productList: [
      "氦检设备",
      "氦检真空箱",
      "自动化设备",
      "新能源设备",
      "混氦设备",
    ],
  },
  telMe: "联系我们",
  environment: "公司环境",
  headOffice: "总 部",
  site: "地 址",
  phone: "咨询热线1",
  transmissionOfTruth: "咨询热线2",
  wx: "联系微信",
  help: "咨询热线1",
  email: "服务邮箱",
  leaveWord: {
    message: "留言信息",
    name: "您的姓名",
    phone: "联系电话",
    email: "邮箱地址",
    address: "联系地址",
    title: "留言主题",
    content: "留言内容",
  },
  beianhao: "备案号",
  bah_num: "沪ICP备2024091906号-1",
  firend: "合作伙伴",
};
export const en = {
  more: "more",
  learnMore: "learn more",
  empty: "No data available",
  product: "Product classification",
  productIntroduce: "Product introduction",
  news: "News",
  case: "Wonderful case",
  server: "Be a trusted service provider",
  company: "Company philosophy",
  companyList: [
    {
      title: " Integrity Management ",
      desc: " Pay attention to integrity management, integrity to customers, integrity to employees, to be an honest business",
      img: "http://47.117.168.187:8899/images/a1.png",
    },
    {
      title: " Technological Innovation ",
      desc: " Continuous technological innovation, strive for the latest technology, to create the greatest value",
      img: "http://47.117.168.187:8899/images/a2.png",
    },
    {
      title: " Common Development ",
      desc: " Common development, common progress and shared results with employees and partners",
      img: "http://47.117.168.187:8899/images/a3.png",
    },
    {
      title: " Corporate Vision ",
      desc: " The team grows together, seeks steady development, and creates a sustainable operating model",
      img: "http://47.117.168.187:8899/images/a4.png",
    },
  ],
  footer: {
    about: " About",
    aboutList: [" Company Profile ", " Corporate culture "],
    product: " Product ",
    productList: [
      "helium inspection equipment",
      "the helium test chamber",
      "automation equipment",
      "new energy equipment",
      "mixed helium equipment",
    ],
  },
  telMe: "Contact us",
  environment: "Corporate environment",
  headOffice: "Head office",
  site: "Site",
  phone: "Helpline 1",
  transmissionOfTruth: "Helpline 2",
  wx: "wechat",
  help: "Helpline 1",
  email: "Email",
  leaveWord: {
    message: "Message",
    name: "name",
    phone: "phone",
    email: "email",
    address: "address",
    title: "subject",
    content: "content",
  },
  beianhao: "Internet Content Provider",
  bah_num: "Shanghai ICP  2024091906-1",
  firend: "Cooperative partner",
};
